import React, { useState, useEffect } from "react";
import "../Styles/home.css";
import { Link, useNavigate } from "react-router-dom";

// =====================================================
// GALLERY IMAGES
// Add more images here whenever you want
// =====================================================

const galleryImages = [
  "/Gallery/freshers1.jpeg",
  "/Gallery/freshers3.jpeg",
  "/Gallery/freshers2.jpeg",
  "/Gallery/freshers4.jpeg",
  "/Gallery/freshers5.jpeg",

  // Add more like this:
  // "/Gallery/image4.jpeg",
  // "/Gallery/image5.jpeg",
];

function Slider() {
  const navigate = useNavigate();

  const [showTopBtn, setShowTopBtn] = useState(false);
  const [currentImage, setCurrentImage] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  // =====================================================
  // SCROLL TO TOP BUTTON
  // =====================================================

  useEffect(() => {
    const handleScroll = () => {
      setShowTopBtn(window.scrollY > 400);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // =====================================================
  // AUTO IMAGE SLIDER
  // =====================================================

  useEffect(() => {
    if (isPaused || galleryImages.length <= 1) return;

    const interval = setInterval(() => {
      setCurrentImage((prev) =>
        prev === galleryImages.length - 1 ? 0 : prev + 1
      );
    }, 3000);

    return () => {
      clearInterval(interval);
    };
  }, [isPaused]);

  // =====================================================
  // PREVIOUS IMAGE
  // =====================================================

  const previousImage = () => {
    setCurrentImage((prev) =>
      prev === 0 ? galleryImages.length - 1 : prev - 1
    );
  };

  // =====================================================
  // NEXT IMAGE
  // =====================================================

  const nextImage = () => {
    setCurrentImage((prev) =>
      prev === galleryImages.length - 1 ? 0 : prev + 1
    );
  };

  return (
    <section className="home-dark">

      {/* =====================================================
          HEADER
      ===================================================== */}

      <div className="section-heading">

        <span>DEPARTMENTAL CULTURE</span>

        <h2>
          Recent <span>Activities</span>
        </h2>

      </div>


      {/* =====================================================
          TWO CARDS
      ===================================================== */}

      <div className="activity-grid">

        <Link to="/events" className="activity-card">

          <h5>Click Here</h5>

          <h3>Events</h3>

          <p>
            The society organizes technical talks,
            industrial visits, workshops, competitions
            and departmental events for Civil Engineering
            students at IIT Kanpur.
          </p>

        </Link>


        <Link to="/strengths" className="activity-card">

          <h5>Our Strengths</h5>

          <h3>Strengths</h3>

          <p>
            Our alumni network, faculty guidance,
            industry collaborations and technical
            community create opportunities beyond classrooms.
          </p>

        </Link>

      </div>


      {/* =====================================================
          SOCE MERCHANDISE
      ===================================================== */}

      <div className="merchandise-section">

        <div className="merchandise-heading">

          <span>OFFICIAL SOCE MERCHANDISE</span>

          <h2>
            SOCE Merchandise <span>2026</span>
          </h2>

          <p>
            Check out our official merchandise and place your order.
          </p>

        </div>


        {/* ================= MERCHANDISE POSTER ================= */}

        <div className="merchandise-poster">

          <img
            src="/Gallery/merchendise.png"
            alt="SOCE Merchandise 2026"
          />

        </div>


        {/* ================= ORDER BUTTON ================= */}

        <div className="merchandise-order">

          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLSc0tADck2p0Sxcvb7xAi2h65BHwSZcCzuMmrS0rbEuszygwWw/viewform?pli=1"
            target="_blank"
            rel="noopener noreferrer"
            className="order-now-btn"
          >
            Order Now →
          </a>

          <p>
            Click the button above to fill out the order form.
          </p>

        </div>

      </div>


      {/* =====================================================
          DIVIDER
      ===================================================== */}

      <div className="section-divider"></div>


      {/* =====================================================
          FEATURED EVENT
      ===================================================== */}

      <div className="featured-event">

        <div className="event-left">

          <div className="event-top">

            <div className="event-badge">
              ● Recent Activity
            </div>

          </div>


          <h1>FRESHER'S PARTY</h1>

          <h2>Welcome Y26</h2>


          <div className="event-quote">
            "New campus, new friends, new adventures — let’s make the journey unforgettable!"
          </div>


          <p>
            Welcome, Batch of Y26! Get ready to step into a new chapter
            of your college life and become a part of the Civil Engineering
            family. Join us for an evening of fun, interaction,
            and memorable moments with your seniors and batchmates.
          </p>


          <h4>
            Your IITK journey starts here. Let’s make it memorable!
          </h4>

        </div>


        <div className="event-right">

          <img
            src="/Gallery/freshers26.png"
            alt="Freshers"
          />

        </div>

      </div>


      {/* =====================================================
          MOMENTS FROM SOCE
      ===================================================== */}

      <div
        className="gallery-slider-section"
        onMouseEnter={() => setIsPaused(true)}
        onMouseLeave={() => setIsPaused(false)}
      >

        {/* ================= HEADING ================= */}

        <div className="gallery-slider-heading">

          <span>MEMORABLE MOMENTS</span>

          <h2>
            Moments from <span>SOCE</span>
          </h2>

        </div>


        {/* ================= IMAGE SLIDER ================= */}

        <div className="gallery-slider">

          {/* LEFT ARROW */}

          <button
            className="gallery-arrow gallery-arrow-left"
            onClick={previousImage}
            aria-label="Previous image"
          >
            &#10094;
          </button>


          {/* IMAGE VIEWPORT */}

          <div className="gallery-viewport">

            <div
              className="gallery-track"
              style={{
                transform: `translateX(-${currentImage * 100}%)`,
              }}
            >

              {galleryImages.map((image, index) => (

                <div
                  className="gallery-slide"
                  key={index}
                >

                  <img
                    src={image}
                    alt={`SOCE moment ${index + 1}`}
                  />

                </div>

              ))}

            </div>

          </div>


          {/* RIGHT ARROW */}

          <button
            className="gallery-arrow gallery-arrow-right"
            onClick={nextImage}
            aria-label="Next image"
          >
            &#10095;
          </button>

        </div>


        {/* ================= DOTS ================= */}

        <div className="gallery-dots">

          {galleryImages.map((_, index) => (

            <button
              key={index}
              className={
                currentImage === index
                  ? "gallery-dot active"
                  : "gallery-dot"
              }
              onClick={() => setCurrentImage(index)}
              aria-label={`Go to image ${index + 1}`}
            />

          ))}

        </div>

      </div>


      {/* =====================================================
          CONTACT
      ===================================================== */}

      <div className="contact-banner">

        <h2>
          Get in touch with any questions,
          ideas, or feedback
        </h2>

        <button onClick={() => navigate("/contact")}>
          Contact Us
        </button>

      </div>


      {/* =====================================================
          SCROLL TO TOP
      ===================================================== */}

      {showTopBtn && (

        <button
          className="top-btn"
          onClick={() =>
            window.scrollTo({
              top: 0,
              behavior: "smooth",
            })
          }
        >
          ↑
        </button>

      )}

    </section>
  );
}

export default Slider;